"use client";

import { type JSX } from "react";
import { AtomicLayoutSection, AtomicQuerySummary } from "@coveo/atomic-react";
import { ClientOnly } from "../../../atoms/ClientOnly";
import { type SearchSummaryProps } from "./search-summary.props";

const QUERY_SUMMARY_STYLES = `
  atomic-query-summary::part(highlight) {
    color: #006bd3;
  }
  atomic-query-summary {
    color: #67768b;
  }
`;

// Note: must be rendered inside a <SearchContainer> (which provides
// AtomicSearchInterface). Wrapping in AtomicPageWrapper here would create
// a nested AtomicSearchInterface conflict.
export const Default = (props: SearchSummaryProps): JSX.Element => {
  console.log("---->[SearchSummary:Default] Component", props.params);

  const id = props.params?.RenderingIdentifier;

  return (
    <div
      className={`search-summary flex justify-start mt-2 pl-(--spacing-sixteen) ${props.params?.styles ?? ""}`}
      data-role="search-summary-component"
    >
      <ClientOnly>
        <AtomicLayoutSection id={id ?? undefined} section="main">
          <AtomicLayoutSection section="status">
            <style>{QUERY_SUMMARY_STYLES}</style>
            <AtomicQuerySummary />
          </AtomicLayoutSection>
        </AtomicLayoutSection>
      </ClientOnly>
    </div>
  );
};
